import './platform-styles.scss';
// import './CustomHTMLElement/CustomHTMLElement';
import  PaymentComponentExt  from './PaymentComponentExt/PaymentComponentExt';
import TileComponentExt from './TileComponentExt/TileComponentExt';
import PEPaymentComponentExt from './PEPaymentComponentExt/PEPaymentComponentExt';
import PremiumAuditAccountTable from './PremiumAuditAccountTable/PremiumAuditAccountTable';
import PremiumAuditCEDocumentsTable from './PremiumAuditCEDocumentsTable/PremiumAuditCEDocumentsTable';
import ClauseComponentExt from './ClausesExt/ClauseComponentExt';
import ClausesComponentVMExt from './ClausesExt/ClausesComponentVMExt';
import SingleClauseComponentVMExt from './ClausesExt/SingleClauseComponentVMExt';
import ScheduleItemsComponentExt from './ScheduleItemsComponentExt/ScheduleItemsComponentExt';
import { ModalHeader } from "./cpmi-modal-next/ModalHeader/ModalHeader";
import { ModalFooter } from "./cpmi-modal-next/ModalFooter/ModalFooter";
import { ModalBody } from "./cpmi-modal-next/ModalBody/ModalBody";


const cpmiplatformComponentMap = {
   
    TileComponentExt:{component:'TileComponentExt'},
    PaymentComponentExt:{component:'PaymentComponentExt'},
    PEPaymentComponentExt:{component:'PEPaymentComponentExt'},
    PremiumAuditAccountTable: {component: 'PremiumAuditAccountTable'},
  	PremiumAuditCEDocumentsTable: {component: 'PremiumAuditCEDocumentsTable'},
    ClauseComponentExt: { component: 'ClauseComponentExt' },
    ClausesComponentVMExt: { component: 'ClausesComponentVMExt' },
    SingleClauseComponentVMExt: { component: 'SingleClauseComponentVMExt' },
    ScheduleItemsComponentExt: { component: 'ScheduleItemsComponentExt' },
    ModalHeader:{component:'ModalHeader'},
    ModalFooter:{component:'ModalFooter'},
    ModalBody:{componet:'ModalBody'},
};

const cpmiplatformComponents = {
    
    TileComponentExt,
    PaymentComponentExt,
    PEPaymentComponentExt,
    PremiumAuditAccountTable,
  	PremiumAuditCEDocumentsTable,
    ClauseComponentExt: ClauseComponentExt,
    ClausesComponentVMExt: ClausesComponentVMExt,
    SingleClauseComponentVMExt,
    ScheduleItemsComponentExt,
    ModalBody,
    ModalFooter,
    ModalHeader,
   
};

export {
    
    TileComponentExt,
    PaymentComponentExt,
    PEPaymentComponentExt,
    PremiumAuditAccountTable,
  	PremiumAuditCEDocumentsTable,
    cpmiplatformComponentMap,
    cpmiplatformComponents,
    ClauseComponentExt,
    ClausesComponentVMExt,
    SingleClauseComponentVMExt,
    ScheduleItemsComponentExt,
    ModalBody,
    ModalFooter,
    ModalHeader,
    
};
